import { StringBufAggsHisto } from './getHistoAndBasicAggs.types';

export interface HistoSummary {
	hasNull: boolean;
	hasControl1: boolean;
	hasBackspace: boolean;
	hasTab: boolean;
	hasLf: boolean;
	hasControl2: boolean;
	hasCr: boolean;
	hasControl3: boolean;
	hasDel: boolean;
	hasHigh: boolean;
	hasControl: boolean;
	allNonNull: boolean;
	allAsciiPrintable: boolean;
	allAsciiPrintableCrLf: boolean;
	allAsciiPrintableCrLfNull: boolean;
	allAscii: boolean;
}

export const enum LineEnding {
	Crlf,
	Lf,
	Unknown,
	None,
}

export interface StringBufInfo extends StringBufAggsHisto, HistoSummary {
	lineEnding: LineEnding;
}
